import { createElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { createHandle } from 'services/breadcrumbs/breadcrumbs';
import { PaymentReconciliationRoutes } from 'support/types';
import { Filters } from 'components/Filters/Filters';
import { Page } from 'components/Page/Page';

import { PaymentReconciliationCompletedTabContent } from './components/PaymentReconciliationCompletedTabContent/PaymentReconciliationCompletedTabContent';
import { PaymentReconciliationOpenTabContent } from './components/PaymentReconciliationOpenTabContent/PaymentReconciliationOpenTabContent';
import { PaymentReconciliationTabs } from './components/PaymentReconciliationTabs/PaymentReconciliationTabs';
import { useReconciliationFilters } from './filters';

const tabComponents = [PaymentReconciliationOpenTabContent, PaymentReconciliationCompletedTabContent];
export const PaymentReconciliation = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const { filters, filterValues, updateFilters, clearAllFilters } = useReconciliationFilters('payment-reconciliation');

  return (
    <Page>
      <Page.Head
        title={t('common:mainMenu.paymentReconciliation')}
        description={t('paymentReconciliation:listPage.description')}
        padding={{ bottom: false }}
        border={{ bottom: false }}
      >
        <div className="flex w-full flex-col gap-3 pb-6">
          <PaymentReconciliationTabs selectedIndex={selectedTab} onTabSelected={setSelectedTab} />
          <Filters
            propertyFilters={filters}
            onFiltersChange={updateFilters}
            filterValues={filterValues}
            clearAllFilters={clearAllFilters}
          />
        </div>
      </Page.Head>
      <Page.Section>
        <div className="-mt-6">
          {createElement(tabComponents[selectedTab], {
            key: selectedTab,
            filterValues,
            clearAllFilters,
          })}
        </div>
      </Page.Section>
    </Page>
  );
};

PaymentReconciliation.handle = createHandle(() => {
  return {
    label: (t) => t('paymentReconciliation:listPage.breadcrumbs'),
    to: PaymentReconciliationRoutes.root,
    key: PaymentReconciliationRoutes.root,
  };
});
